
const Loader = ({ primary, size, showLoader, inline = false }) => {
    const loaderSize = size ? size : inline ? '100%' : 30;
    const stroke = inline ? '12%' : '1.8px';

    return (
        <div className={`${inline ? 'absolute inset-0' : 'bg-[rgba(0,0,0,0.9)] fixed top-0 w-full h-full'} items-center justify-center z-20 ${showLoader ? 'flex' : 'hidden'}`}>
            <div
                style={{
                    width: loaderSize,
                    height: loaderSize,
                    position: 'relative',
                    animation: 'loader-spin 1.3s linear infinite',
                    aspectRatio: '1 / 1',
                }}
            >
                <div
                    style={{
                        width: '100%',
                        height: '100%',
                        borderRadius: '50%',
                        background: `conic-gradient(from 270deg, transparent 0%, ${primary} 100%)`,
                        WebkitMask: `radial-gradient(farthest-side, transparent calc(100% - ${stroke}), #000 calc(100% - ${stroke}))`,
                        mask: `radial-gradient(farthest-side, transparent calc(100% - ${stroke}), #000 calc(100% - ${stroke}))`,
                    }}
                />
                {!inline && (
                    <div
                        style={{
                            position: 'absolute',
                            width: stroke,
                            height: stroke,
                            borderRadius: '50%',
                            backgroundColor: primary,
                            top: '50%',
                            left: 0,
                            transform: 'translateY(-50%)',
                        }}
                    />
                )}
            </div>
            <style>{`
                @keyframes loader-spin {
                    to { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    )
}

export default Loader;